import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CountyAutocompleteInputComponent } from './county-autocomplete-input.component';

@NgModule({
  declarations: [CountyAutocompleteInputComponent],
  imports: [CommonModule, FormsModule],
  exports: [CountyAutocompleteInputComponent]
})
export class CountyAutocompleteInputModule {}
